export const COLORS = {
  BLACK: ["#122533", "#122533", "#122533", "#122533", "#122533", "#122533", "#122533", "#122533", "#122533", "#122533",],
  WHITE: ["#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE", "#EFEEEE",],
  CYAN: ["#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6", "#3CB1A6",],
}